import React, { Component } from 'react';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import ChartIndex from './chartIndex';
import { Loader } from 'react-loaders';

@connect(
  state=>state.tenant,
  null
)
export default class Home extends Component{
  componentDidMount() {
    $("#activity, #project-context").show();
  }
  render() {
    let block = !this.props.chosenTenant;
    return (
      <div>
        <div id="ribbon">
          {/*<span className="ribbon-button-alignment">*/}
              {/*<span id="refresh"*/}
                    {/*className="btn btn-ribbon"*/}
                    {/*data-action="resetWidgets"*/}
                    {/*data-title="refresh"*/}
                    {/*rel="tooltip"*/}
                    {/*data-placement="bottom"*/}
                    {/*data-original-title="<i className='text-warning fa fa-warning'></i> Warning! This will reset all your widget settings."*/}
                    {/*data-html="true">*/}
                  {/*<i className="fa fa-refresh" />*/}
              {/*</span>*/}
          {/*</span>*/}
          <ol className="breadcrumb">
            <li>Dashboard</li>
          </ol>
        </div>
        <div id="content">
          <div className="row">
            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-4">
              <h1 className="page-title txt-color-blueDark">
                <i className="fa-fw fa fa-home" />
                Dashboard
              </h1>
            </div>
          </div>
          <section id="widget-grid" className="">
            <div className="row">
              <article className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="jarviswidget jarviswidget-color-darken"
                     id="wid-id-5"
                     data-widget-sortable="false"
                     data-widget-deletebutton="false"
                     data-widget-editbutton="false">
                  <header>
                    <span className="widget-icon">
                      <i className="fa fa-bar-chart-o" />
                    </span>
                    <h2 id="h2Text">Stats Chart</h2>
                  </header>

                  <div>
                    <div className="jarviswidget-editbox" />
                    <div className="widget-body">
                      <BlockUi tag="div"
                               loader={<Loader active type="ball-grid-pulse" color="#808080"/>}
                               blocking={block}
                               renderChildren={false}>
                        <ChartIndex />
                      </BlockUi>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </section>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/dashboard/model/home.js